// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/**
 * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @author John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @license GNU AGPL version 3 or any later version
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
.material-design-icon[data-v-7aacfcf3] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.avatardiv[data-v-7aacfcf3] {
  position: relative;
  display: inline-block;
  width: var(--size);
  height: var(--size);
}
.avatardiv--unknown[data-v-7aacfcf3] {
  position: relative;
  background-color: var(--color-main-background);
  white-space: normal;
}
.avatardiv[data-v-7aacfcf3]:not(.avatardiv--unknown) {
  background-color: var(--color-main-background) !important;
  box-shadow: 0 0 5px #0000000d inset;
}
.avatardiv--with-menu[data-v-7aacfcf3] {
  cursor: pointer;
}
.avatardiv--with-menu .action-item[data-v-7aacfcf3] {
  position: absolute;
  top: 0;
  left: 0;
}
.avatardiv--with-menu[data-v-7aacfcf3] .action-item__menutoggle {
  cursor: pointer;
  opacity: 0;
}
.avatardiv--with-menu[data-v-7aacfcf3]:focus-within .action-item__menutoggle,
.avatardiv--with-menu[data-v-7aacfcf3]:hover .action-item__menutoggle,
.avatardiv--with-menu.avatardiv--with-menu-loading[data-v-7aacfcf3] .action-item__menutoggle {
  opacity: 1;
}
.avatardiv--with-menu:focus-within img[data-v-7aacfcf3],
.avatardiv--with-menu:hover img[data-v-7aacfcf3],
.avatardiv--with-menu.avatardiv--with-menu-loading img[data-v-7aacfcf3] {
  opacity: .3;
}
.avatardiv--with-menu[data-v-7aacfcf3] .action-item__menutoggle,
.avatardiv--with-menu img[data-v-7aacfcf3] {
  transition: opacity var(--animation-quick);
}
.avatardiv--with-menu[data-v-7aacfcf3] .button-vue,
.avatardiv--with-menu[data-v-7aacfcf3] .button-vue__icon {
  height: var(--size);
  min-height: var(--size);
  width: var(--size) !important;
  min-width: var(--size);
}
.avatardiv .avatardiv__initials-wrapper[data-v-7aacfcf3] {
  display: block;
  height: var(--size);
  width: var(--size);
  background-color: var(--color-main-background);
  border-radius: 50%;
}
.avatardiv .avatardiv__initials-wrapper .avatardiv__initials[data-v-7aacfcf3] {
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  width: 100%;
  text-align: center;
  font-weight: 400;
}
.avatardiv img[data-v-7aacfcf3] {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.avatardiv .material-design-icon[data-v-7aacfcf3] {
  width: var(--size);
  height: var(--size);
}
.avatardiv .avatardiv__user-status[data-v-7aacfcf3] {
  box-sizing: border-box;
  position: absolute;
  right: -4px;
  bottom: -4px;
  min-height: 18px;
  min-width: 18px;
  max-height: 18px;
  max-width: 18px;
  height: 40%;
  width: 40%;
  line-height: 15px;
  font-size: var(--default-font-size);
  border: 2px solid var(--color-main-background);
  background-color: var(--color-main-background);
  background-repeat: no-repeat;
  background-size: 16px;
  background-position: center;
  border-radius: 50%;
}
.acli:hover .avatardiv .avatardiv__user-status[data-v-7aacfcf3] {
  border-color: var(--color-background-hover);
  background-color: var(--color-background-hover);
}
.acli.active .avatardiv .avatardiv__user-status[data-v-7aacfcf3] {
  border-color: var(--color-primary-element-light);
  background-color: var(--color-primary-element-light);
}
.avatardiv .avatardiv__user-status--icon[data-v-7aacfcf3] {
  border: none;
  background-color: transparent;
}
.avatardiv .popovermenu-wrapper[data-v-7aacfcf3] {
  position: relative;
  display: inline-block;
}
.avatar-class-icon[data-v-7aacfcf3] {
  display: block;
  border-radius: 50%;
  background-color: var(--color-background-darker);
  height: 100%;
}
`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcAvatar-BozWHt1s.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;;;;;;;;;;;;;;;;;;;;EAoBE;AACF;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,8CAA8C;EAC9C,mBAAmB;AACrB;AACA;EACE,yDAAyD;EACzD,mCAAmC;AACrC;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;AACA;EACE,eAAe;EACf,UAAU;AACZ;AACA;;;EAGE,UAAU;AACZ;AACA;;;EAGE,WAAW;AACb;AACA;;EAEE,0CAA0C;AAC5C;AACA;;EAEE,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,8CAA8C;EAC9C,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,UAAU;EACV,iBAAiB;EACjB,mCAAmC;EACnC,8CAA8C;EAC9C,8CAA8C;EAC9C,4BAA4B;EAC5B,qBAAqB;EACrB,2BAA2B;EAC3B,kBAAkB;AACpB;AACA;EACE,2CAA2C;EAC3C,+CAA+C;AACjD;AACA;EACE,gDAAgD;EAChD,oDAAoD;AACtD;AACA;EACE,YAAY;EACZ,6BAA6B;AAC/B;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,gDAAgD;EAChD,YAAY;AACd","sourcesContent":["@charset \"UTF-8\";\n/**\n * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @author John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @license GNU AGPL version 3 or any later version\n *\n * This program is free software: you can redistribute it and/or modify\n * it under the terms of the GNU Affero General Public License as\n * published by the Free Software Foundation, either version 3 of the\n * License, or (at your option) any later version.\n *\n * This program is distributed in the hope that it will be useful,\n * but WITHOUT ANY WARRANTY; without even the implied warranty of\n * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the\n * GNU Affero General Public License for more details.\n *\n * You should have received a copy of the GNU Affero General Public License\n * along with this program. If not, see <http://www.gnu.org/licenses/>.\n *\n */\n.material-design-icon[data-v-7aacfcf3] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.avatardiv[data-v-7aacfcf3] {\n  position: relative;\n  display: inline-block;\n  width: var(--size);\n  height: var(--size);\n}\n.avatardiv--unknown[data-v-7aacfcf3] {\n  position: relative;\n  background-color: var(--color-main-background);\n  white-space: normal;\n}\n.avatardiv[data-v-7aacfcf3]:not(.avatardiv--unknown) {\n  background-color: var(--color-main-background) !important;\n  box-shadow: 0 0 5px #0000000d inset;\n}\n.avatardiv--with-menu[data-v-7aacfcf3] {\n  cursor: pointer;\n}\n.avatardiv--with-menu .action-item[data-v-7aacfcf3] {\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n.avatardiv--with-menu[data-v-7aacfcf3] .action-item__menutoggle {\n  cursor: pointer;\n  opacity: 0;\n}\n.avatardiv--with-menu[data-v-7aacfcf3]:focus-within .action-item__menutoggle,\n.avatardiv--with-menu[data-v-7aacfcf3]:hover .action-item__menutoggle,\n.avatardiv--with-menu.avatardiv--with-menu-loading[data-v-7aacfcf3] .action-item__menutoggle {\n  opacity: 1;\n}\n.avatardiv--with-menu:focus-within img[data-v-7aacfcf3],\n.avatardiv--with-menu:hover img[data-v-7aacfcf3],\n.avatardiv--with-menu.avatardiv--with-menu-loading img[data-v-7aacfcf3] {\n  opacity: .3;\n}\n.avatardiv--with-menu[data-v-7aacfcf3] .action-item__menutoggle,\n.avatardiv--with-menu img[data-v-7aacfcf3] {\n  transition: opacity var(--animation-quick);\n}\n.avatardiv--with-menu[data-v-7aacfcf3] .button-vue,\n.avatardiv--with-menu[data-v-7aacfcf3] .button-vue__icon {\n  height: var(--size);\n  min-height: var(--size);\n  width: var(--size) !important;\n  min-width: var(--size);\n}\n.avatardiv .avatardiv__initials-wrapper[data-v-7aacfcf3] {\n  display: block;\n  height: var(--size);\n  width: var(--size);\n  background-color: var(--color-main-background);\n  border-radius: 50%;\n}\n.avatardiv .avatardiv__initials-wrapper .avatardiv__initials[data-v-7aacfcf3] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  display: block;\n  width: 100%;\n  text-align: center;\n  font-weight: 400;\n}\n.avatardiv img[data-v-7aacfcf3] {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n.avatardiv .material-design-icon[data-v-7aacfcf3] {\n  width: var(--size);\n  height: var(--size);\n}\n.avatardiv .avatardiv__user-status[data-v-7aacfcf3] {\n  box-sizing: border-box;\n  position: absolute;\n  right: -4px;\n  bottom: -4px;\n  min-height: 18px;\n  min-width: 18px;\n  max-height: 18px;\n  max-width: 18px;\n  height: 40%;\n  width: 40%;\n  line-height: 15px;\n  font-size: var(--default-font-size);\n  border: 2px solid var(--color-main-background);\n  background-color: var(--color-main-background);\n  background-repeat: no-repeat;\n  background-size: 16px;\n  background-position: center;\n  border-radius: 50%;\n}\n.acli:hover .avatardiv .avatardiv__user-status[data-v-7aacfcf3] {\n  border-color: var(--color-background-hover);\n  background-color: var(--color-background-hover);\n}\n.acli.active .avatardiv .avatardiv__user-status[data-v-7aacfcf3] {\n  border-color: var(--color-primary-element-light);\n  background-color: var(--color-primary-element-light);\n}\n.avatardiv .avatardiv__user-status--icon[data-v-7aacfcf3] {\n  border: none;\n  background-color: transparent;\n}\n.avatardiv .popovermenu-wrapper[data-v-7aacfcf3] {\n  position: relative;\n  display: inline-block;\n}\n.avatar-class-icon[data-v-7aacfcf3] {\n  display: block;\n  border-radius: 50%;\n  background-color: var(--color-background-darker);\n  height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
